import { connect } from "react-redux";
import flatten from "lodash.flatten";
import ResultsTable from "../ResultsTable";

export const mapStateToProps = state => {
  const {
    inputs = "",
    results,
    discards,
    resultsByCount,
    sorter,
    slider,
    output
  } = state;
  const { min, max, defaultValue, shouldShowSlider } = slider;
  const values = Object.values(resultsByCount);
  const sliceStart = defaultValue[0];
  const sliceEnd = defaultValue[1] + 1;
  const slicedValues = values.slice(sliceStart, sliceEnd);
  const idsByCount = flatten(slicedValues);
  const data = idsByCount.reduce((accumulator, currentValue) => {
    if (!discards.includes(currentValue)) {
      const icon = inputs[0].split(" ").includes(currentValue)
        ? "form"
        : "search";
      const result = { ...results[currentValue], icon };
      accumulator.push(result);
    }
    return accumulator;
  }, []);
  const sliderValues = values.map(x => results[x[0]].media_count);

  return {
    data,
    sorter,
    min,
    max,
    defaultValue,
    shouldShowSlider,
    sliderValues,
    output
  };
};

export const mapDispatchToProps = dispatch => {
  return {
    onFilterChange: values => {
      const start = values[0];
      const end = values[1];
      dispatch({
        type: "CHANGE_SLIDER",
        defaultValue: [start, end]
      });
    },
    onSelectOneRow: ({ hashtag }) => {
      dispatch({ type: "SELECT_ONE_ROW", hashtag });
    },
    onDeselectOneRow: ({ hashtag }) => {
      dispatch({ type: "DESELECT_ONE_ROW", hashtag });
    },
    onSelectAll: ({ hashtags }) => {
      dispatch({ type: "SELECT_ALL_ROWS", hashtags });
    },
    onDeselectAll: ({ hashtags }) => {
      dispatch({ type: "DESELECT_ALL_ROWS", hashtags });
    },
    onDiscardResult: hashtag => {
      dispatch({ type: "DISCARD_RESULT", hashtag });
    },
    onTableChange: ({ columnKey, order }) => {
      dispatch({ type: "TABLE_CHANGE", order, columnKey });
    }
  };
};

// Container Component
const ResultsTableContainer = connect(mapStateToProps, mapDispatchToProps)(
  ResultsTable
);

export default ResultsTableContainer;



// WEBPACK FOOTER //
// ./src/containers/ResultsTableContainer.js